<template>
  <div class="dashboard-layout">
    <!-- 顶部Header区域 -->
    <Header />
    
    <!-- 主体内容区域 -->
    <div class="main-container">
      <el-container class="layout-container">
        <!-- 左侧菜单 -->
        <el-aside width="220px" class="sidebar-aside">
          <Sidebar />
        </el-aside>
        
        <!-- 右侧内容区域 -->
        <el-main class="content-main">
          <div class="content-header">
            <Breadcrumb />
          </div>
          <div class="content-body">
            <router-view />
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import Header from '../components/Header.vue'
import Breadcrumb from '../components/Breadcrumb.vue'

export default {
  name: 'LayoutPage',
  components: { Sidebar, Header, Breadcrumb }
}
</script>

<style scoped>
.dashboard-layout {
  height: 100vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
}

.main-container {
  flex: 1;
  overflow: hidden;
}

.layout-container {
  height: 100%;
}

.sidebar-aside {
  background: white;
  border-right: 1px solid #eee;
  overflow-y: auto;
  height: 100%;
}

.content-main {
  background: #f5f7fa;
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content-header {
  height: 60px;
  background: white;
  display: flex;
  align-items: center;
  padding: 0 10px;
  border-bottom: 1px solid #eee;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  flex-shrink: 0;
}

.content-header h2 {
  margin: 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
}

.content-body {
  padding: 10px;
  flex: 1;
  overflow-y: auto;
  box-sizing: border-box;
}

.content-card :deep(.el-card__body) {
  padding: 20px;
}

.content-card p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}
</style>